// Central, editable content for Chopstick Chinese Corner.
// NOTE: Business details below are PLACEHOLDERS — replace with authentic
// information before going live. No reviews/awards/stats are fabricated.

export const BUSINESS = {
  name: "Chopstick Chinese Corner",
  tagline: "Modern Chinese, made for the neighbourhood.",
  // --- PLACEHOLDERS: replace with real details ---
  phoneDisplay: "+91 98XXX XXXXX",
  phoneHref: "+9198XXXXXXXX",
  email: "hello@chopstickcorner.example",
  addressLine1: "address 1",
  addressLine2: "Sector xxx, Gurugram",
  addressRegion: "Haryana, India",
  hoursShort: "Open daily · 12:00 PM – 11:00 PM",
  hours: [
    { day: "Monday – Thursday", time: "12:00 PM – 11:00 PM" },
    { day: "Friday – Saturday", time: "12:00 PM – 11:30 PM" },
    { day: "Sunday", time: "12:00 PM – 11:00 PM" },
  ],
  mapEmbed:
    "https://www.google.com/maps?q=Sector+100+Gurugram+Haryana&output=embed",
  directionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=Sector+100+Gurugram+Haryana",
  zomatoUrl: "https://www.zomato.com/",
  swiggyUrl: "https://www.swiggy.com/",
  instagram: "https://instagram.com/",
  isPlaceholder: true,
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Menu", to: "/menu" },
  { label: "Gallery", to: "/gallery" },
  { label: "Reviews", to: "/reviews" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export const WHY_US = [
  {
    title: "Wok-fired to order",
    body: "Every dish leaves the kitchen seconds after it hits the plate — high heat, fast hands, honest flavour.",
    icon: "Flame",
  },
  {
    title: "Hand-pulled noodles",
    body: "Fresh dough stretched daily in-house for that springy, satisfying bite you can only get from scratch.",
    icon: "Utensils",
  },
  {
    title: "Sourced with care",
    body: "Crisp local produce and quality proteins, balanced with authentic sauces and aromatics.",
    icon: "Leaf",
  },
  {
    title: "Built for the neighbourhood",
    body: "A warm, contemporary corner in Sector xxx — equally right for a quick lunch or a long dinner.",
    icon: "MapPin",
  },
];

export const CATEGORIES = [
  {
    id: "dim-sum",
    name: "Dim Sum & Starters",
    desc: "Steamer baskets, crispy bites and the small plates everyone fights over.",
    image:
      "https://images.unsplash.com/photo-1523905330026-b8bd1f5f320e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxnb3VybWV0JTIwY2hpbmVzZSUyMGZvb2QlMjBkYXJrJTIwbW9vZHl8ZW58MHx8fHwxNzg0NzA5NDMxfDA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-7",
  },
  {
    id: "noodles",
    name: "Noodles & Rice",
    desc: "Hand-pulled noodles, wok-tossed rice and everything in between.",
    image:
      "https://images.pexels.com/photos/36771456/pexels-photo-36771456.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "md:col-span-5",
  },
  {
    id: "wok",
    name: "From the Wok",
    desc: "Sizzling mains in signature sauces — the heart of the kitchen.",
    image:
      "https://images.pexels.com/photos/12455439/pexels-photo-12455439.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "md:col-span-5",
  },
  {
    id: "sides",
    name: "Sides & Sweets",
    desc: "Comforting sides and a short, sweet finish to the meal.",
    image:
      "/images/sweetsWithIceCreams.jpg",
    span: "md:col-span-7",
  },
];

// Sample menu — representative dishes with placeholder prices & images.
// To use YOUR OWN photos: either (a) paste a hosted image URL, or (b) drop the
// file into /public/menu/ and set image: "/menu/your-file.jpg" (see note below).
export const MENU = [
  {
    category: "Dim Sum & Starters",
    items: [
      { name: "Steamed Chicken Dumplings", desc: "Ginger, spring onion, soy-chilli dip", price: "₹—", tag: "Signature", image: "/images/Steamed-Chicken-Dumplings.jpeg" },
      { name: "Veg Spring Rolls", desc: "Crisp rolls, sweet-chilli sauce", price: "₹—", image: "/images/Veg-Spring-Rolls.jpeg" },
      { name: "Prawn Har Gow", desc: "Translucent skin, whole prawn filling", price: "₹—", image: "/images/Prawn-Har-Gow.jpeg" },
      { name: "Crispy Chilli Potato", desc: "Tossed in tangy schezwan glaze", price: "₹—", tag: "Veg", image: "/images/Crispy-Chilli-Potato.jpeg" },
    ],
  },
  {
    category: "Noodles & Rice",
    items: [
      { name: "Hand-Pulled Chilli Garlic Noodles", desc: "Wok-tossed, fresh daily dough", price: "₹—", tag: "Signature", image: "https://images.pexels.com/photos/36771456/pexels-photo-36771456.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=400" },
      { name: "Burnt Garlic Fried Rice", desc: "Wok hei, egg, spring onion", price: "₹—", image: "/images/Burnt-Garlic-Fried-Rice.jpeg" },
      { name: "Veg Hakka Noodles", desc: "Julienned vegetables, house sauce", price: "₹—", tag: "Veg", image: "https://images.unsplash.com/photo-1585032226651-759b368d7246?auto=format&fit=crop&w=400&q=70" },
      { name: "Chicken Schezwan Rice", desc: "Fiery, aromatic, comforting", price: "₹—", image: "/images/Chicken-Schezwan-Rice.jpeg" },
    ],
  },
  {
    category: "From the Wok",
    items: [
      { name: "Kung Pao Chicken", desc: "Peanuts, dried chilli, black vinegar", price: "₹—", tag: "Signature", image: "/images/Kung-Pao-Chicken.jpeg" },
      { name: "Chilli Paneer Dry", desc: "Bell peppers, onion, soy-chilli", price: "₹—", tag: "Veg", image: "/images/Chilli-Paneer-Dry.jpeg" },
      { name: "Sliced Fish in Black Bean", desc: "Silky fish, fermented black bean", price: "₹—", image: "/images/Sliced-Fish.jpeg" },
      { name: "Mapo Tofu", desc: "Soft tofu, chilli-bean sauce", price: "₹—", tag: "Veg", image: "/images/mapo-tofu.jpg" },
    ],
  },
  {
    category: "Sides & Sweets",
    items: [
      { name: "Steamed Jasmine Rice", desc: "Fragrant, fluffy", price: "₹—", tag: "Veg", image: "/images/steamed-jasmine-rice.jpg" },
      { name: "Royal Indulgence Dessert Platter", desc: "A Royal Assortment of Sweet Delights", price: "₹—", image: "/images/sweetsWithIceCreams.jpg" },
      { name: "Date Pancakes", desc: "Warm, chewy, lightly sweet", price: "₹—", tag: "Veg", image: "/images/Date-Pancakes.jpeg" },
      { name: "Gajar Halwa Symphony", desc: "Gajar Halwa, Elevated with Ice Creams", price: "₹—", tag: "Veg", image: "/images/Gajar-Halwa-Symphony.jpeg" },
    ],
  },
];

export const HOW_IT_WORKS = [
  { step: "01", title: "Choose your table", body: "Walk in or call ahead — we'll have a spot ready for you in Sector xxx." },
  { step: "02", title: "Order the classics", body: "Browse the menu, ask our team for favourites, and mix small plates with mains." },
  { step: "03", title: "Eat while it's hot", body: "Everything is wok-fired to order and rushed straight to your table." },
];

// Illustrative testimonials written as generic sample copy — NOT real customer
// reviews. Replace with verified reviews before publishing.
export const REVIEWS = [
  { name: "A. Sharma", role: "Sample review", rating: 5, text: "The hand-pulled noodles are the real deal — springy, smoky and generous. Easily my new go-to in 109." },
  { name: "R. Menon", role: "Sample review", rating: 5, text: "Warm space, quick service and dim sum that disappears in seconds. Perfect for a casual dinner out." },
  { name: "K. Batra", role: "Sample review", rating: 4, text: "Loved the Kung Pao chicken and the chilli garlic noodles. Portions are hearty and the flavours are balanced." },
  { name: "S. Iyer", role: "Sample review", rating: 5, text: "Finally a neighbourhood Chinese spot that feels premium without the fuss. The burnt garlic rice is unreal." },
];

export const GALLERY = [
  { url: "https://images.pexels.com/photos/12455439/pexels-photo-12455439.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200", alt: "Noodle bowl with chopsticks", span: "row-span-2" },
  { url: "https://images.pexels.com/photos/10135116/pexels-photo-10135116.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", alt: "Cozy restaurant interior with warm lighting" },
  { url: "https://images.unsplash.com/photo-1523905330026-b8bd1f5f320e?crop=entropy&cs=srgb&fm=jpg&q=85&w=940", alt: "Steamed dumplings in a bamboo steamer" },
  { url: "/images/Chicken-Schezwan-Rice.jpeg", alt: "Chicken Schezwan Rice" },
  // { url: "https://images.pexels.com/photos/8093533/pexels-photo-8093533.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", alt: "Bamboo steamers top view" },
  { url: "https://images.pexels.com/photos/36771456/pexels-photo-36771456.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200", alt: "Asian noodles with vegetables", span: "row-span-2" },
  { url: "/images/Steamed-Chicken-Dumplings.jpeg", alt: "Steamed Chicken Dumplings" },
  { url: "/images/Veg-Spring-Rolls.jpeg", alt: "Veg Spring Rolls" },
  { url: "/images/Prawn-Har-Gow.jpeg", alt: "Prawn Har Gow" },
  { url: "/images/Kung-Pao-Chicken.jpeg", alt: "Kung Pao Chicken" },
  { url: "/images/Gajar-Halwa-Symphony.jpeg", alt: "Gajar Halwa Symphony" },
  { url: "/images/Burnt-Garlic-Fried-Rice.jpeg", alt: "Burnt Garlic Fried Rice" },
  { url: "/images/Sliced-Fish.jpeg", alt: "Sliced Fish" },
  { url: "/images/Crispy-Chilli-Potato.jpeg", alt: "Crispy Chilli Potato" },
  { url: "/images/Chilli-Paneer-Dry.jpeg", alt: "Chilli Paneer Dry" },
  { url: "/images/mapo-tofu.jpg", alt: "Mapo Tofu" },
  { url: "/images/steamed-jasmine-rice.jpg", alt: "steamed jasmine rice" },
  { url: "/images/Date-Pancakes.jpeg", alt: "Date Pancakes" },
  { url: "/images/sweetsWithIceCreams.jpg", alt: "Royal Indulgence Dessert Platter" },
];

export const FAQS = [
  { q: "Where exactly are you located?", a: "We're in Sector xxx, Gurugram, Haryana. The exact building details on this site are placeholders — please confirm via phone or Google Maps directions until finalised." },
  { q: "Do you take reservations?", a: "For now, the best way to reserve a table is to call us directly. Click-to-call is available across the site and in the mobile action bar." },
  { q: "Can I order for delivery or takeaway?", a: "Yes — you can order via our delivery partners (Zomato / Swiggy) using the links on the site, or call us for takeaway." },
  { q: "Do you have vegetarian and vegan options?", a: "Absolutely. A large part of the menu is vegetarian, and several dishes can be made vegan on request. Look for the 'Veg' tag on the menu." },
  { q: "Is the food very spicy?", a: "Spice levels vary by dish and most can be adjusted. Just let our team know your preference when ordering." },
  { q: "Do you cater for private events?", a: "Please call us to discuss group bookings and event catering. Availability and menus can be tailored to your needs." },
];
